<template>
  <div class="container">
    <template
      v-if="
        shopInfo.supCurrency.indexOf('2') === -1 &&
          shopInfo.supCurrency.indexOf('3') === -1
      "
    >
      <div class="title">
        数据较长建议横屏查看
      </div>
      <div class="table-container">
        <div class="table">
          <div
            v-for="(item, index) in th1"
            :key="item + index"
            class="tr-container"
            :style="'width:' + item.width"
          >
            <div
              v-for="(td, tdIndex) in dailyList"
              :key="td + tdIndex"
              class="tr"
            >
              <div 
                v-if="tdIndex == 0"
                class="th"
              >
                {{ item.name }}
              </div>
              <div 
                class="td"
                :class="[item.class]"
              >
                {{ td[item.prop] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template
      v-if="
        shopInfo.supCurrency.indexOf('1') > -1 &&
          shopInfo.supCurrency.indexOf('2') > -1
      "
    >
      <div class="title">
        数据较长建议横屏查看
      </div>
      <div class="table-container">
        <div class="table">
          <div
            v-for="(item, index) in th2"
            :key="item + index"
            class="tr-container"
            :style="'width:' + item.width"
          >
            <div
              v-for="(td, tdIndex) in dailyList"
              :key="td + tdIndex"
              class="tr"
            >
              <div
                v-if="tdIndex == 0"
                class="th"
              >
                {{ item.name }} 
                <br>
                {{ item.unit }}
              </div>
              <div 
                class="td"
                :class="[item.class]"
              >
                {{ td[item.prop] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template
      v-if="
        shopInfo.supCurrency.indexOf('1') > -1 &&
          shopInfo.supCurrency.indexOf('3') > -1
      "
    >
      <div class="title">
        数据较长建议横屏查看
      </div>
      <div class="table-container">
        <div class="table">
          <div
            v-for="(item, index) in th3"
            :key="item + index"
            class="tr-container"
            :style="'width:' + item.width"
          >
            <div
              v-for="(td, tdIndex) in dailyList"
              :key="td + tdIndex"
              class="tr"
            >
              <div
                v-if="tdIndex == 0"
                class="th"
              >
                {{ item.name }} 
                <br>
                {{ item.unit }}
              </div>
              <div 
                class="td"
                :class="[item.class]"
              >
                {{ td[item.prop] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { GetWeek, GetMonth } from "@/api/report";
import { floatAdd } from "@/utils/util";
export default {
  name: "Index",
  data() {
    return {
      th1: [
        {
          name: "业务日期",
          width: "90px",
          prop: "retailTime"
        },
        {
          name: "今日收入",
          width: "80px",
          class: "td-c1",
          prop: "tdayIncomeEur"
        },
        {
          name: "现金收入",
          width: "80px",
          class: "td-c2",
          prop: "cashIncomeEur"
        },
        {
          name: "刷卡收入",
          width: "80px",
          class: "td-c2",
          prop: "cardIncomeEur"
        },
        {
          name: "ANCV",
          width: "80px",
          class: "td-c2",
          prop: "incomePayply"
        },
        {
          name: "其他收入",
          width: "80px",
          class: "td-c2",
          prop: "otherIncomeEur"
        },
        {
          name: "支出",
          width: "80px",
          class: "td-c3",
          prop: "tdayOutlayEur"
        },
        {
          name: "客流",
          width: "80px",
          class: "td-c4",
          prop: "tdayCustomerCount"
        }
      ],
      th2: [
        {
          name: "业务日期",
          width: "90px",
          prop: "retailTime"
        },
        {
          name: "今日收入",
          unit: "（€）",
          width: "80px",
          class: "td-c1",
          prop: "tdayIncomeEur"
        },
        {
          name: "今日收入",
          unit: "（CHF）",
          width: "80px",
          class: "td-c1",
          prop: "tdayIncomeChf"
        },
        {
          name: "现金收入",
          unit: "（€）",
          width: "80px",
          class: "td-c2",
          prop: "cashIncomeEur"
        },
        {
          name: "现金收入",
          unit: "（CHF）",
          width: "80px",
          class: "td-c2",
          prop: "cashIncomeChf"
        },
        {
          name: "刷卡收入",
          unit: "（€）",
          width: "80px",
          class: "td-c2",
          prop: "cardIncomeEur"
        },
        {
          name: "ANCV",
          width: "80px",
          class: "td-c2",
          prop: "incomePayply"
        },
        {
          name: "其他收入",
          unit: "（€）",
          width: "80px",
          class: "td-c2",
          prop: "otherIncomeEur"
        },
        {
          name: "其他收入",
          unit: "（CHF）",
          width: "80px",
          class: "td-c2",
          prop: "otherIncomeChf"
        },
        {
          name: "今日支出",
          unit: "（€）",
          width: "80px",
          class: "td-c3",
          prop: "tdayOutlayEur"
        },
        {
          name: "今日支出",
          unit: "（CHF）",
          width: "80px",
          class: "td-c3",
          prop: "tdayOutlayChf"
        },
        {
          name: "客流",
          width: "80px",
          class: "td-c4",
          prop: "tdayCustomerCount"
        }
      ],
      th3: [
        {
          name: "业务日期",
          width: "90px",
          prop: "retailTime"
        },
        {
          name: "今日收入",
          unit: "（€）",
          width: "80px",
          class: "td-c1",
          prop: "tdayIncomeEur"
        },
        {
          name: "今日收入",
          unit: "（饭票）",
          width: "80px",
          class: "td-c1",
          prop: "tdayIncomeMeal"
        },
        {
          name: "现金收入",
          unit: "（€）",
          width: "80px",
          class: "td-c2",
          prop: "cashIncomeEur"
        },
        {
          name: "刷卡收入",
          unit: "（€）",
          width: "80px",
          class: "td-c2",
          prop: "cardIncomeEur"
        },
        {
          name: "ANCV",
          width: "80px",
          class: "td-c2",
          prop: "incomePayply"
        },
        {
          name: "饭票收入",
          width: "80px",
          class: "td-c2",
          prop: "mealIncome"
        },
        {
          name: "其他收入",
          unit: "（€）",
          width: "80px",
          class: "td-c2",
          prop: "otherIncomeEur"
        },
        {
          name: "其他收入",
          unit: "（饭票）",
          width: "80px",
          class: "td-c2",
          prop: "otherIncomeMeal"
        },
        {
          name: "今日支出",
          unit: "（€）",
          width: "80px",
          class: "td-c3",
          prop: "tdayOutlayEur"
        },
        {
          name: "饭票支出",
          width: "80px",
          class: "td-c3",
          prop: "tdayOutlayMeal"
        },
        {
          name: "客流",
          width: "80px",
          class: "td-c4",
          prop: "tdayCustomerCount"
        }
      ],
      shopInfo: {},
      dailyList: [],
      type: "" //1本周 2本月
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.shopInfo = JSON.parse(localStorage.getItem("sushiWechatShopInfo"));
    this.getDetail();
  },
  methods: {
    getDetail() {
	let Func = this.type == 1 ? GetWeek : GetMonth
      Func(this.shopInfo.sid).then(res => {
        if (res.code == 0) this.dailyList = res.dailyList;
        let _sum = {
          retailTime: "合计",
          cardIncomeEur: 0,
          cashIncomeChf: 0,
          cashIncomeEur: 0,
          eveningCustomerCount: 0,
          listDailyOut: 0,
          mealIncome: 0,
          monthChf: 0,
          monthEur: 0,
          monthMeal: 0,
          morningCustomerCount: 0,
          incomePayply: 0,
          otherIncomeChf: 0,
          otherIncomeEur: 0,
          otherIncomeMeal: 0,
          tdayCustomerCount: 0,
          tdayIncomeSum: 0,
          tdayIncomeChf: 0,
          tdayIncomeEur: 0,
          tdayIncomeMeal: 0,
          tdayOutlayEur: 0,
          tdayOutlayMeal: 0,
          tdayOutlayChf: 0
        };
        this.dailyList.forEach(item => {
          for (let attr in item) {
            if (attr in _sum && attr != "retailTime")
              _sum[attr] = floatAdd(_sum[attr], item[attr] || 0);
          }
        });
        this.dailyList.push(_sum);
        console.log(this.dailyList);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
$border-color: #f2f2f2;
.container {
  padding: 10px;
}
.title {
  font-size: 16px;
  padding: 10px 0;
}
.table-container {
  width: 100%;
  overflow-x: auto;
  font-size: 14px;
  .table {
    display: flex;
    flex-wrap: nowrap;
    min-width: 100%;
    float: left;
    border-left: 1px solid $border-color;
    // border-top: 1px solid $border-color;
  }
  .tr-container {
    border-right: 1px solid $border-color;
  }
  .th,
  .td {
    border-bottom: 1px solid $border-color;
    text-align: center;
  }
  .th {
    background: rgba(209, 232, 255, 1);
    color: #fff;
    font-size: 12px;
    padding: 0 10px;
    display: flex;
    height: 30px;
    align-items: center;
    justify-content: center;
  }
  .td {
    font-size: 12px;
    padding: 10px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }
}
</style>
